<button [ngClass]="'no-hidden'" *ngIf="show" class="btn btn-primary" (click)="scrollTop()">
    <fa-icon [icon]="['fas','arrow-up']"></fa-icon> Subir
</button>